function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "size");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M146,423.2H109.3l84.7-84.4-21.2-21.3L88.3,401.8V365.6h-30v87.7H146Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M366,423.2v30h87.7V365.6h-30v36.2l-84.5-84.2-21.2,21.3,84.7,84.4Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M88.3,110.2l84.5,84.2,21.2-21.3L109.3,88.8H146v-30H58.3v87.7h30Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M339.2,194.4l84.5-84.2v36.2h30V58.8H366v30h36.7l-84.7,84.4Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,0V512H512V0ZM482,482H30V30H482Z"
});

var SvgSize = function SvgSize(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "e69c6c91-98c9-4aaf-b350-0d343b9d747b",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSize, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/size.13b750d7.svg";
export { ForwardRef as ReactComponent };